import React from 'react';
import { Translate } from 'core/translate';

const LanguageChange = (lang, country) => {
  const modelSelectorUrlEnglish = '/byo-vc/client/family-first/en/CA';
  const modelSelectorUrlFrench = '/byo-vc/client/family-first/fr/CA';

  if (country === 'CA') {
    return (
      <li className="footer__item">
        <span className="language-toggle__item language-toggle__label">
          <Translate value="component.language.toggle.label" />
        </span>
        <a
          className={`language-toggle__item language-toggle__link " + ${
            lang === 'en' ? 'language-toggle__active' : ''
          }`}
          href={modelSelectorUrlEnglish}>
          <Translate value="component.language.toggle.english" />
        </a>
        <a
          className={`language-toggle__item language-toggle__link " + ${
            lang === 'fr' ? 'language-toggle__active' : ''
          }`}
          href={modelSelectorUrlFrench}>
          <Translate value="component.language.toggle.french" />
        </a>
      </li>
    );
  } else {
    return '';
  }
};

const Footer = props => {
  const { onAdChoicesClicked, lang, country } = props;

  let privacyUrl;

  if (country === 'US') {
    privacyUrl = 'https://www.gm.com/privacy-statement.html';
  }

  if (country === 'CA') {
    privacyUrl = `http://www.gm.ca/gm/${
      lang === 'en' ? 'english' : 'french'
    }/corporate/about/privacy/overview`;
  }

  return (
    <div className="footer">
      <ul className="footer__links">
        <li className="footer__item footer__copy">
          <Translate value="byo.footer.gm" />
        </li>
        <li className="footer__item">
          <a
            id="footer-privacy-link"
            className="footer__link"
            href={privacyUrl}>
            <Translate value="byo.footer.privacy" />
          </a>
        </li>
        <li className="footer__item">
          <a
            id="footer-ad-choices-link"
            className="footer__link"
            onClick={onAdChoicesClicked}>
            <img
              className="footer__image"
              alt=""
              src="//c.betrad.com/pub/icon1.png"
            />
            <Translate value="byo.footer.adchoice" />
          </a>
        </li>
        <LanguageChange lang={lang} country={country} />
      </ul>
      <div className="footer-disclosure">
        <div className="footer-disclosure__header">
          <Translate value="byo.model.selector.disclosure.header" />
        </div>
        <p className="footer-disclosure__content">
          <Translate value="byo.model.selector.disclosure.content1" />
        </p>
        <p className="footer-disclosure__content">
          <Translate value="byo.model.selector.disclosure.content2" />
        </p>
        <p className="footer-disclosure__content">
          <Translate value="byo.model.selector.disclosure.content3" />
        </p>
        <p className="footer-disclosure__content">
          <Translate value="byo.model.selector.disclosure.content4" />
        </p>
      </div>
    </div>
  );
};

export default Footer;
